<div class="modal-header">
    <h4 class="modal-title pull-left">Suggest Properties</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose($event)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="banner-subpage">
  <div class="search-div advanced-search-div clearfix search-div-02 buy-page-advance-search">
    <div class="advanced-search-inner">
      <div class="form-group bigdiv location-auto-complete">


        <mat-form-field class="mat-no-border select-highlight mobile-change-select matautocomplete">
          <input matInput
                 placeholder="Tenant, Address, City, State"
                 [matAutocomplete]="auto"
                 [(ngModel)]="searchCriteria.Address"
                 (input)="dataServiceInput$.next($event.target.value)" />

          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPropertyAutocompleteSelect($event.option.value)">

            <ng-container *ngIf="dataService$ | async as items">
              <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                          [value]="item">
                <div class="split-container">
                  <span>{{ item.PropertyName }}</span>
                  <span class="location-type">{{ item.Type }}</span>
                </div>
              </mat-option>
            </ng-container>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="form-group smalldiv pricediv">
        <div class="btn-group select-dropdown clearfix right-border" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
            Price <span class="caret"></span>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
            <div class="form-group margin0">
              <div class="row">
                <div class="resp-col margin-bottom-15">
                  <div class="textbox-with-btn-left">
                    <input type="text" class="search-field-input form-control" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" maxlength="15" [(ngModel)]="searchCriteria.PriceFrom" placeholder="- Min -" value="{{searchCriteria.PriceFrom|number}}" />
                    <span class="leftlabel">$</span>
                  </div>
                </div>
                <div class="resp-col">
                  <div class="textbox-with-btn-left">
                    <input type="text" class="search-field-input form-control" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" maxlength="15" [(ngModel)]="searchCriteria.PriceTo" placeholder="- Max -" value="{{searchCriteria.PriceTo|number}}" />
                    <span class="leftlabel">$</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group smalldiv">
        <div class="select-dropdown right-border multiselectdesign">
          <!--<angular2-multiselect [data]="inputAssetTypes" [(ngModel)]="searchCriteria.AssetTypes" [settings]="defaultTypeSettings"></angular2-multiselect>-->
          <mat-form-field class="mat-no-border select-highlight mobile-change-select property-type-form">
            <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.AssetTypes" placeholder="Property Type" multiple>
              <mat-select-trigger *ngIf="searchCriteria?.AssetTypes?.length > 1">
                <span>{{ searchCriteria?.AssetTypes?.length }} items selected</span>
              </mat-select-trigger>
              @for (inputAssetType of inputAssetTypes; track inputAssetType) {
              <mat-option [value]="inputAssetType.id" class="multi-dropdown-item">{{inputAssetType.name}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="inputAssetTypes.length === 0" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group smalldiv pricediv">
        <div class="btn-group select-dropdown clearfix right-border" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
            Cap Rate <span class="caret"></span>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
            <div class="form-group margin0">
              <div class="row">
                <div class="resp-col margin-bottom-15">
                  <div class="textbox-with-4character textbox-with-2character textbox-with-btn">
                    <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" [dropSpecialCharacters]="false" inputmode="decimal" mask="999.99" [(ngModel)]="searchCriteria.CapRateFrom" placeholder="- Min -" (change)="validateFilters()">
                    <span class="rightlabel">%</span>
                  </div>
                </div>
                <div class="resp-col">
                  <div class="textbox-with-4character  textbox-with-2character textbox-with-btn">
                    <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" [dropSpecialCharacters]="false" inputmode="decimal" mask="999.99" [(ngModel)]="searchCriteria.CapRateTo" placeholder="- Max -" (change)="validateFilters()">
                    <span class="rightlabel">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="form-group smalldiv">
        <div class="select-dropdown right-border multiselectdesign">
            <ss-multiselect-dropdown [options]="inputRatings" [(ngModel)]="searchCriteria.Ratings" [settings]="defaultCreditSettings" [texts]="defaultCreditText"></ss-multiselect-dropdown>
        </div>
    </div>-->
      <div class="form-group smalldiv">
        <div class="select-dropdown right-border multiselectdesign">
          <!--<angular2-multiselect [data]="inputTerms" [(ngModel)]="searchCriteria.Terms" [settings]="defaultTermSettings"></angular2-multiselect>-->
          <mat-form-field class="mat-no-border select-highlight mobile-change-select property-type-form">
            <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.Terms" placeholder="Term" multiple>
              <mat-select-trigger *ngIf="searchCriteria?.Terms?.length > 1">
                <span>{{ searchCriteria?.Terms?.length }} items selected</span>
              </mat-select-trigger>
              @for (inputTerm of inputTerms; track inputTerm) {
              <mat-option [value]="inputTerm.id" class="multi-dropdown-item">{{inputTerm.name}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="inputTerms.length === 0" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <button class="searchbtn margin-left-5" (click)="onPropertySearch()">Search</button>
      <a href="javascript:void(0);" class="btn-icon01" (click)="onResetClick()">
        <i aria-hidden="true" class="icon-reset"></i>
        Reset
      </a>

    </div>
  </div>
</div>
<div class="modal-body table-fixed margin-top-20">  
    <div class="table-responsive margin-bottom-20">
        <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
            <thead>
                <tr>
                    <th class="remove" style="position:static; cursor:auto;">Select</th>
                    <th>OM</th>
                    <th class="property-name-column">Tenant</th>                   
                    <th>State</th>
                    <th>Property Type</th>
                    <th>Property Status</th>
                    <th>Asking Price</th>
                    <th>Rent NOI</th>
                    <th>Credit Rating</th>
                    <th>Cap Rate</th>
                    <th>Remaining Term</th>
                    <th>Lease Structure</th>
                    <th>Area (SQ FT)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let prop of propertySuggestList">
                    <td>
                        <label class="custom-checkbox withoutlabel">
                            <input [disabled]="prop.DisabledSelection" type="checkbox" [(ngModel)]="prop.IsChecked" (ngModelChange)="onChecked(prop);">
                            <i></i>
                        </label>
                    </td>
                    <td>
                        <span *ngIf="prop.OMFilePath == null">-</span>
                        <a *ngIf="prop.OMFilePath!=null" href={{prop.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(prop.OMFilePath!=null)}">
                        <i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}</a>
                    </td>
                    <td class="min-width-td"><p><a target="_blank" href="#" routerLink="/viewproperty/{{prop.Guid}}">{{ prop.PropertyName }}</a></p></td>

                    <td><p>{{ prop.State ? prop.State : '-' }}</p></td>
                    <td><p tooltip="{{prop.AssetType}}">{{ prop.AssetType ? _commonService.GetPropertyTypeWithCount(prop.AssetType) : '-' }}</p></td>
                    <td><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract'}">{{ prop.PropertyStatus }}</p></td>
                    <td><p class="whitespacenowrap">{{(prop.Price!=null&&prop.Price>=0 && prop.IsShowPrice) ? '$ '+(prop.Price |number:0) : '-'}}</p></td>
                    <td><p class="whitespacenowrap">{{ (prop.RentNOI) ? '$ '+(prop.RentNOI | number:0) : '-' }}</p></td>
                    <td><p>{{ prop.RatingType ? prop.RatingType + (prop.Rating ? ' (' + prop.Rating + ')' : '') : '-' }}</p></td>
                    <td>
                      <p *ngIf="prop.CharacteristicsId == 1">ZCF</p>

                      <p *ngIf="prop.CharacteristicsId != 1">{{ (prop.CapRate && prop.IsShowPrice) ? (prop.CapRate | number : '1.2-2') + '%' : '-'}}</p>
                    </td>
                    <td *ngIf="prop.PropertyFor == '602'"><p class="whitespacenowrap">{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>
                    <td><p class="whitespacenowrap">{{ prop.LeaseStructure ? prop.LeaseStructure : '-'}}</p></td>
                    <td><p>{{ prop.BuildingSize ? (prop.BuildingSize |number:0) : '-' }}</p></td>
                </tr>
                <tr *ngIf="propertySuggestList?.length === 0&&!IsLoading">
                    <td colspan="12" class="no-data-available">
                        <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>


    <div class="text-right" style="padding-bottom:30px;">
        <button class="btn btn-lg btn-default " (click)="onClose($event)">Cancel</button>
        <button class="btn btn-success btn-lg" (click)="onAdd($event);">Suggest</button>
    </div>
    
</div>



